import * as tslib_1 from "tslib";
import { FileSyncServiceBase } from '../../sync/file-sync.service.base';
import { SettingsService } from '../../sync/settings.service';
import { BaseLayoutComponent } from './base-layout.component';
var StiglechnerLayoutComponent = /** @class */ (function (_super) {
    tslib_1.__extends(StiglechnerLayoutComponent, _super);
    function StiglechnerLayoutComponent(settings, fileSync) {
        return _super.call(this, settings, fileSync) || this;
    }
    return StiglechnerLayoutComponent;
}(BaseLayoutComponent));
export { StiglechnerLayoutComponent };
